import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ControllerDtoDaoOutputDto } from "~/api/apiRouteTypes/DaosRoute";
import { RootState } from ".";

interface TMerch {
  refetchTrigger: boolean;
  merchstoreUrl: ControllerDtoDaoOutputDto["merchstoreUrl"];
  mobileIsAdmin: boolean;
  hasMerchItems: boolean;
}

interface TMerchState {
  merch: TMerch;
}

const initialState: TMerchState = {
  merch: {
    refetchTrigger: false,
    merchstoreUrl: null,
    mobileIsAdmin: false,
    hasMerchItems: false,
  },
};

export const merchSlice = createSlice({
  name: "merch",
  initialState,
  reducers: {
    mutateRefetchMerchsTrigger: (state) => {
      state.merch.refetchTrigger = !state.merch.refetchTrigger;
    },
    setMerchstoreUrl: (
      state,
      action: PayloadAction<TMerch["merchstoreUrl"]>,
    ) => {
      state.merch.merchstoreUrl = action.payload;
    },
    setMerchMobileIsAdmin: (
      state,
      action: PayloadAction<TMerch["mobileIsAdmin"]>,
    ) => {
      state.merch.mobileIsAdmin = action.payload;
    },
    setHasMerchItems: (
      state,
      action: PayloadAction<TMerch["hasMerchItems"]>,
    ) => {
      state.merch.hasMerchItems = action.payload;
    },
  },
});

export const {
  mutateRefetchMerchsTrigger,
  setMerchstoreUrl,
  setMerchMobileIsAdmin,
  setHasMerchItems,
} = merchSlice.actions;

export const selectMerch = (state: RootState) => state.merch.merch;

export default merchSlice.reducer;
